import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';

import {
  GLOBAL_MANUFACTURERS_BY_IDS,
  GLOBAL_MANUFACTURERS_FOR_DROPDOWN,
  getURLWithSearchParams,
} from 'lib/networking/endpoints';
import ProductListFilter from 'lib/enums/ProductListFilter';
import { removeEmpty } from 'lib/utils/objectUtils';
import { httpGet } from 'lib/networking/http';
import SearchableScrollableMultiSelect from 'components/shared/SearchableScrollableMultiSelect';

function ManufacturerFilter({ selectedValues, updateFilters, isMultiSelect = true }) {
  const [initOptions, setInitOptions] = useState([]);

  // initial load
  useEffect(() => {
    const url = getURLWithSearchParams(
      GLOBAL_MANUFACTURERS_BY_IDS,
      removeEmpty({
        ids: selectedValues?.length ? selectedValues.join(',') : null,
      }),
    );
    httpGet(url).then(res => {
      if (res.status === 200) {
        const manufacturers = res.data?.data;
        if (manufacturers?.length) {
          setInitOptions(
            manufacturers.map(manufacturer => ({
              label: manufacturer.name,
              value: manufacturer.id,
            })),
          );
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form.Group>
      <Form.Label>Select Manufacturers</Form.Label>
      <SearchableScrollableMultiSelect
        onChange={options => {
          if (isMultiSelect) {
            // For multi-select: options is an array
            updateFilters(
              ProductListFilter.MANUFACTURER_IDS,
              options?.map(option => option.value),
            );
          } else {
            // For single-select: options is a single object or null
            updateFilters(ProductListFilter.MANUFACTURER_IDS, options);
          }
        }}
        fetchUrl={GLOBAL_MANUFACTURERS_FOR_DROPDOWN}
        optionMapper={manufacturer => ({ label: manufacturer.name, value: manufacturer.id })}
        initOptions={initOptions}
        isMultiSelect={isMultiSelect}
      />
    </Form.Group>
  );
}

ManufacturerFilter.propTypes = {
  selectedValues: PropTypes.array,
  updateFilters: PropTypes.func,
  isMultiSelect: PropTypes.bool,
};

export default ManufacturerFilter;
